import { z } from 'zod';

export const OrganizationUserSummarySchema = z.object({
  userId: z.uuid().nullable(),
  inviteId: z.uuid().nullable(),
  email: z.email(),
  fullName: z.string(),
  status: z.enum(['invited', 'active', 'inactive', 'blocked']),
  scopeType: z.enum(['TENANT', 'PLACE']),
  profileName: z.string(),
  placeName: z.string().nullable(),
});

export type OrganizationUserSummary = z.infer<typeof OrganizationUserSummarySchema>;

export const ListOrganizationUsersResponseSchema = z.object({
  organizationId: z.uuid(),
  items: z.array(OrganizationUserSummarySchema),
});

export type ListOrganizationUsersResponse = z.infer<typeof ListOrganizationUsersResponseSchema>;
